import classNames from "classnames";
import type { FunctionComponent } from "preact";
import type { ReactNode } from "preact/compat";

export const Slide: FunctionComponent<{
  children: ReactNode;
  carouselType: "quote" | "default" | "large";
  active: boolean;
}> = ({ children, carouselType, active }) => {
  return (
    <li
      aria-current={active}
      class={classNames(
        "Slide flex relative basis-full h-full items-center snap-start",
        {
          ["w-screen max-w-6xl px-8 lg:px-16"]: carouselType === "default",
          ["w-screen lg:w-[50vw] px-8 lg:px-16"]: carouselType === "quote",
          ["w-screen"]: carouselType === "large",
        },
      )}
    >
      {children}
    </li>
  );
};
